var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"521c04fe68fbe1f850fe9e78922465c3b57674ad"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/main";

// All client side configuration is stood up on top of application event consumption.
// The only reason this file exists is because of the unflexible Sentry API(They puke without it).
export {};
